module.exports = __webpack_public_path__ + "static/media/iconWithdrawal.a789db16.svg";